import React, { useEffect, useState } from "react";
import Navbar from "../../Navbar/Navbar";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import baseURL from "../../config";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Cookies from "js-cookie";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  Select,
  MenuItem,
  TextField,
  Grid,
  Card,
  CircularProgress,
  CardContent,
  Typography,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControlLabel, Checkbox,
  FormControl,
  InputLabel
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";




const EditContractTable = () => {
  const [formData, setFormData] = useState({
    currency: "",
    crewingAgentStatus: "",
    remark: "",
    formI: null, // File upload
    visaFee: { checked: false, amount: "", remarks: "" },
    medicalFee: { checked: false, amount: "", remarks: "" },
    flagDoc: { checked: false, amount: "", remarks: "" }
  });
  const [currencies, setCurrencies] = useState([]);


  const navigate = useNavigate();
  const [openModal, setOpenModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalDocuments, setModalDocuments] = useState([]);
  const [loading, setLoading] = useState(false);


  const location = useLocation();
  const { crewingAgentId, contract } = location.state || {};

  useEffect(() => {
    const fetchCurrencies = async () => {
      try {
        // Primary: Open Exchange Rates (no key needed for currencies.json)
        const { data } = await axios.get("https://openexchangerates.org/api/currencies.json");
        const list = Object.entries(data).map(([code, name]) => ({ code, name }));
        setCurrencies(list.sort((a, b) => a.code.localeCompare(b.code)));
      } catch (e) {
        // Fallback: exchangerate.host
        try {
          const res = await axios.get("https://api.exchangerate.host/symbols");
          const symbols = res.data?.symbols ?? {};
          const list = Object.values(symbols).map(({ code, description }) => ({
            code,
            name: description,
          }));
          setCurrencies(list.sort((a, b) => a.code.localeCompare(b.code)));
        } catch (err) {
          console.error("Failed to fetch currencies from both sources:", err);
        }
      }
    };
    fetchCurrencies();
  }, []);



  const handleCurrencyChange = (e) => {
    setFormData((prev) => ({ ...prev, currency: e.target.value }));
  };


  if (!contract) {
    return <div>Error: Contract data is missing.</div>;
  }


  const handleOpenModal = (title, docs) => {
    setModalTitle(title);
    setModalDocuments(docs);
    setOpenModal(true);
  };


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  const handleFileChange = (e) => {
    setFormData((prevData) => ({
      ...prevData,
      formI: e.target.files[0],
    }));
  };


  const handleSubmit = async (e, id) => {
    e.preventDefault();

    // Prevent multiple submissions
    if (loading) return;
    setLoading(true);

    const userEmail = Cookies.get("userEmail");
    const approvedBy = userEmail === "admin@gmail.com" ? "Admin" : "Crewing Agent";
    const token = localStorage.getItem("token");

    try {
      let response;

      if (formData.formI) {
        // Case 1: With Form I (FormData for file upload)
        const formDataToSend = new FormData();
        formDataToSend.append("contractId", contract?._id);
        formDataToSend.append("crewingAgentId", crewingAgentId || id);
        formDataToSend.append("formI", formData.formI);

        response = await axios.post(`${baseURL}/api/contract-status`, formDataToSend, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        });

        toast.success("Contract status saved successfully!");
        setTimeout(() => {
          setLoading(false);
          navigate(-1);
        }, 1500);
        return; // ✅ stop further code
      } else {
        // Case 2: Without Form I (JSON Payload)
        const payload = {
          contractId: contract?._id,
          crewingAgentId: crewingAgentId || id,
          crewingAgentStatus: formData.crewingAgentStatus,
          remark: formData.remark || "",
          approvedBy,
        };

        // Add fees only when status is "Approve"
        if (formData.crewingAgentStatus === "Approve") {
          // Always send all fee fields with default 0 amounts to match backend expectations

          payload.fee = {
            currency: formData.currency,
            visaFee: {
              amount: 0,
              remark: ""
            },
            medicalFee: {
              amount: 0,
              remark: ""
            },
            flagDocFee: {
              amount: 0,
              remark: ""
            }
          };

          // Override with actual values when checkboxes are checked
          if (formData.visaFee?.checked && formData.visaFee.amount) {
            payload.fee.visaFee = {
              amount: Number(formData.visaFee.amount) || 0,
              remark: formData.visaFee.remarks || ""
            };
          }

          if (formData.medicalFee?.checked && formData.medicalFee.amount) {
            payload.fee.medicalFee = {
              amount: Number(formData.medicalFee.amount) || 0,
              remark: formData.medicalFee.remarks || ""
            };
          }

          if (formData.flagDoc?.checked && formData.flagDoc.amount) {
            payload.fee.flagDocFee = {
              amount: Number(formData.flagDoc.amount) || 0,
              remark: formData.flagDoc.remarks || ""
            };
          }
        }

        response = await axios.post(`${baseURL}/api/contract-status`, payload, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });
      }

      console.log('Success:', response.data);
      // Add any success handling here (e.g., show success message, redirect, etc.)
      toast.success("Contract status saved successfully!");
      setTimeout(() => {
        setLoading(false);
        navigate(-1);
      }, 1500);

    } catch (error) {
      console.error('Error:', error);
      // Add error handling here (e.g., show error message)
    } finally {
      setLoading(false);
    }
  };


  return (
    <>
      <Navbar />
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          Edit Contract Table
        </Typography>


        <TableContainer component={Paper} sx={{ mb: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <strong>Sr. No.</strong>
                </TableCell>
                <TableCell>
                  <strong>Vessel Owner</strong>
                </TableCell>
                <TableCell>
                  <strong>Crew Details</strong>
                </TableCell>
                <TableCell>
                  <strong>Crewing Agent</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>1</TableCell>


                {/* Vessel Owner Column */}
                <TableCell>{console.log("edit", contract)}
                  {!crewingAgentId && ( // Hide the button if crewingAgentId is present
                    <Typography>
                      <strong>Company:</strong>{" "}
                      {contract.vesselOwner?.[0]?.company_shortname || contract.vesselOwner?.company_shortname}
                    </Typography>
                  )}
                  <Typography>
                    <strong>Vessel:</strong>{" "}
                    {contract.ShipDetails?.[0]?.vesselname || contract.ShipDetails?.vesselname}
                  </Typography>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() =>
                      handleOpenModal(
                        "Vessel Documents",
                        [
                          // "seagreement",
                          // "cdagreement",
                          "pipolicydocument",
                          "maritimelabourconvention",
                          "fsdocument",
                          "dmlcp1",
                          "dmlc2",
                          "registryDocument",
                          "SMD",
                          "Cargo_PassengerShipSafety",
                        ].map((doc) => ({
                          name: doc.replace(/([A-Z])/g, " $1"),
                          filePath:
                            contract?.ShipDetails?.[0]?.[doc]?.filePath || contract?.ShipDetails?.[doc]?.filePath,
                        }))
                      )
                    }
                  >
                    View Vessel Documents
                  </Button>
                </TableCell>


                {/* Crew Details Column */}
                <TableCell>
                  {/* {console.log("contract.crewdetails", contract.crewdetails)} */}
                  <Typography>
                    <strong>Name:</strong> {contract.crewdetails?.[0]?.name || contract.crewdetails?.name}
                  </Typography>
                  <Typography>
                    <strong>Indos No.:</strong>{" "}
                    {contract.crewdetails?.[0]?.indosno || contract.crewdetails?.indosno}
                  </Typography>
                  <Typography>
                    <strong>Mobile No.:</strong>{" "}
                    {contract.crewdetails?.[0]?.mobile || contract.crewdetails?.mobile}
                  </Typography>
                  <Typography>
                    <strong>Email:</strong>{" "}
                    {contract.crewdetails?.[0]?.email || contract.crewdetails?.email}
                  </Typography>
                  <Typography>
                    <strong>Rank:</strong>{" "}
                    {contract.crewdetails?.[0]?.rankname || contract.crewdetails?.rankname}
                  </Typography>


                  {/* Button to Open Modal with Crew Documents */}
                  <Button
                    variant="contained"
                    color="secondary"
                    onClick={() =>
                      handleOpenModal(
                        "Crew Documents",
                        [
                          { key: "crewDocument", label: "Crew CV" },
                          { key: "passportDocument", label: "Passport" },
                          { key: "cdcDocument", label: "CDC" },
                          { key: "iloDocument", label: "ILO" },
                          { key: "stcwDocument", label: "STCW" },
                          { key: "stsdsdDocument", label: "STSDSD" },
                          { key: "CrewPhotoDocument", label: "Crew Photo" },
                          { key: "yellowfeverDocument", label: "YELLOW FEVER VACCINE" },
                          { key: "CovidVaccineDocument", label: "COVID 19 VACCINE" },
                          { key: "watchkeepingDocument", label: "Watchkeeping" },
                          { key: "CopDocument", label: "COP" },
                          { key: "cookcocDocument", label: "Cook COC" },
                          { key: "officercocDocument", label: "Officer COC" },
                          { key: "gocDocument", label: "GOC" },
                          { key: "gmdssDocument", label: "GMDSS" },
                          { key: "h2sDocument", label: "H2S" },
                          { key: "huetDocument", label: "HUET" },
                          { key: "highvoltageDocument", label: "High Voltage" },
                          { key: "brmDocument", label: "BRM" },
                          { key: "degreeDiplomaDocument", label: "Degree/Diploma" },
                          { key: "bosietDocument", label: "BOSIET" },
                          { key: "signContratDocument", label: "Signed Contract" },
                          { key: "pscrbDocument", label: "PSCRB" },
                          { key: "sidDocument", label: "SID" },
                          { key: "AFF", label: "Advanced Fire Fighting (AFF)" },
                          { key: "MFA", label: "Medical First Aid (MFA)" },
                          { key: "PSSR", label: "Personal Safety and Social Responsibility (PSSR)" },
                          { key: "SSO", label: "Ship Security Officer (SSO)" },
                          { key: "BTM", label: "Bridge Team Management (BTM)" },
                          { key: "ECDIS", label: "ECDIS" },
                          { key: "contract", label: "Contract" },
                          { key: "BankDocument", label: "Bank Details" },
                        ]
                          .map((doc) => ({
                            name: doc.label,
                            filePath: contract?.crewdetails?.[0]?.[doc.key]?.filePath || contract?.crewdetails?.[doc.key]?.filePath,
                          }))
                          .filter((doc) => doc.filePath !== null) // ✅ Only show documents with filePath
                      )
                    }
                  >
                    View Crew Documents
                  </Button>


                </TableCell>


                {/* Crewing Agent Column */}
                <TableCell>
                  <Typography>
                    <strong>Agent Name:</strong>{" "}
                    {contract.crewingAgent?.[0]?.agentName || contract.crewingAgent?.agentName}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>


        <Card
          sx={{
            p: 2,
            maxWidth: "600px",
            mx: "auto",
            display: "flex",
            flexDirection: "column",
            gap: 2,
          }}
        >
          <CardContent sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <Grid container spacing={2}>
              {/* Check if adminStatus is "Approve" */}
              {console.log("contract.latestStatus", contract)}

              {/* Main condition: Check if crewingAgentStatus is "Approve" and formI is not uploaded yet */}
              {(
                (contract.contractStatus?.[0]?.latestStatus?.crewingAgentStatus ||
                  contract.contractStatus?.latestStatus?.crewingAgentStatus) === "Approve"
              ) &&
                !(
                  contract.contractStatus?.[0]?.formI?.filePath ||
                  contract.contractStatus?.formI?.filePath
                ) ? (
                <>
                  {/* Check isApproved status when crewingAgentStatus is "Approve" */}
                  {(
                    (contract?.contractStatus?.[0]?.fee?.isApproved ||
                      contract?.contractStatus?.fee?.isApproved) === false ||
                    (contract?.contractStatus?.[0]?.fee?.isApproved ||
                      contract?.contractStatus?.fee?.isApproved) === "false"
                  ) ? (
                    <>
                      {/* Show waiting message when isApproved is false */}
                      <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                        <Typography variant="body1" color="warning.main" sx={{ mt: 2, textAlign: "center" }}>
                          Wait for admin approval
                        </Typography>
                      </Grid>
                    </>
                  ) : (
                    (contract?.contractStatus?.[0]?.fee?.isApproved ||
                      contract?.contractStatus?.fee?.isApproved) === true ||
                    (contract?.contractStatus?.[0]?.fee?.isApproved ||
                      contract?.contractStatus?.fee?.isApproved) === "true"
                  ) ? (
                    <>
                      {/* Show Form I upload when isApproved is true */}
                      <Typography variant="body2" color="error" sx={{ mt: 1 }}>
                        Please add Form I
                      </Typography>

                      {/* Form I Upload Field */}
                      <Grid item xs={12} sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
                        <Typography variant="h6">Upload Form I</Typography>
                        <input
                          type="file"
                          onChange={handleFileChange}
                          style={{ height: "35px", padding: "5px" }}
                        />
                      </Grid>

                      {/* Submit Button - visible only when Form I is being uploaded */}
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          fullWidth
                          onClick={(e) =>
                            handleSubmit(
                              e,
                              contract.crewingAgent?.[0]?._id || contract.crewingAgent?._id
                            )
                          }
                          sx={{ height: "40px" }}
                        >
                          {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                        </Button>
                      </Grid>
                    </>
                  ) : (
                    <>
                      {/* Default case when isApproved is undefined/null - show waiting message */}
                      <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", width: "100%" }}>
                        <Typography variant="body1" color="warning.main" sx={{ mt: 2, textAlign: "center" }}>
                          Wait for admin approval
                        </Typography>
                      </Grid>
                    </>
                  )}
                </>
              ) : (
                <>
                  {/* Show status selection form when crewingAgentStatus is not "Approve" OR formI is already uploaded */}
                  {!(
                    contract.contractStatus?.[0]?.formI?.filePath ||
                    contract.contractStatus?.formI?.filePath
                  ) ? (
                    <>
                      <Grid
                        item
                        xs={12}
                        sx={{ display: "flex", flexDirection: "column", width: "100%" }}
                      >
                        <Typography variant="h6">Status</Typography>
                        <Select
                          name="crewingAgentStatus"
                          value={formData.crewingAgentStatus}
                          onChange={handleInputChange}
                          fullWidth
                          size="small"
                          displayEmpty
                        >
                          <MenuItem value="">Select Status</MenuItem>
                          <MenuItem value="Approve">Approved</MenuItem>
                          <MenuItem value="Not Approve">Not Approved</MenuItem>
                          <MenuItem value="Correction">Correction</MenuItem>
                        </Select>
                      </Grid>

                      {/* Remarks Input */}
                      {formData.crewingAgentStatus && (
                        <Grid
                          item
                          xs={12}
                          sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            mb: 2,
                          }}
                        >
                          <Typography variant="h6">Remarks</Typography>
                          <TextField
                            variant="outlined"
                            autoComplete="off"
                            fullWidth
                            size="small"
                            sx={{ height: "40px" }}
                            name="remark"
                            value={formData.remark}
                            onChange={handleInputChange}
                          />

                          {/* Checkboxes with expandable fields */}
                          {formData.crewingAgentStatus === "Approve" && (
                            <>
                              <Box alignItems="center" gap={1} sx={{ mt: 1 }}>
                                <Typography variant="h6">Currency</Typography>
                                {/* Amount Input */}
                                <FormControl fullWidth>
                                  <InputLabel
                                    sx={{
                                      color: '#000000',
                                      fontWeight: 500,
                                      '&.Mui-focused': {
                                        color: '#000000'
                                      }
                                    }}
                                  >
                                    Add Currency
                                  </InputLabel>
                                  <Select
                                    value={formData.currency}
                                    onChange={(e) =>
                                      setFormData((prev) => ({ ...prev, currency: e.target.value }))
                                    }
                                    sx={{
                                      borderRadius: 2,
                                      '& .MuiOutlinedInput-root': {
                                        borderRadius: 2,
                                      },
                                      '& .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#e0e0e0',
                                        borderWidth: 2,
                                      },
                                      '&:hover .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#1976d2',
                                        borderWidth: 2,
                                      },
                                      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                                        borderColor: '#1976d2',
                                        borderWidth: 2,
                                        boxShadow: '0 0 0 3px rgba(25, 118, 210, 0.1)',
                                      },
                                      '& .MuiSelect-select': {
                                        padding: '12px 14px',
                                        fontSize: '16px',
                                      }
                                    }}
                                    MenuProps={{
                                      PaperProps: {
                                        sx: {
                                          borderRadius: 2,
                                          mt: 1,
                                          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
                                          border: '1px solid #f0f0f0',
                                          maxHeight: 300,
                                          '& .MuiMenuItem-root': {
                                            padding: '12px 16px',
                                            borderRadius: 1,
                                            margin: '4px 8px',
                                            fontSize: '14px',
                                            transition: 'all 0.2s ease',
                                            '&:hover': {
                                              backgroundColor: 'rgba(25, 118, 210, 0.08)',
                                              transform: 'translateX(4px)',
                                            },
                                            '&.Mui-selected': {
                                              backgroundColor: 'rgba(25, 118, 210, 0.12)',
                                              fontWeight: 600,
                                              '&:hover': {
                                                backgroundColor: 'rgba(25, 118, 210, 0.15)',
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }}
                                  >
                                    {currencies.map((cur) => (
                                      <MenuItem key={cur.code} value={cur.code}>
                                        {cur.code} - {cur.name}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                              </Box>

                              {[
                                { label: "Visa Fee", key: "visaFee" },
                                { label: "Medical Fee", key: "medicalFee" },
                                { label: "Flag Doc", key: "flagDoc" },
                              ].map(({ label, key }) => (
                                <Box key={key} sx={{ mb: 1 }}>
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={formData[key]?.checked || false}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            [key]: {
                                              ...prev[key],
                                              checked: e.target.checked,
                                            },
                                          }))
                                        }
                                      />
                                    }
                                    label={`${label} (if applicable)`}
                                  />

                                  {formData[key]?.checked && (
                                    <Box sx={{ display: "flex", gap: 2, mt: 1 }}>
                                      <TextField
                                        label="Amount"
                                        size="small"
                                        type="number"
                                        value={formData[key]?.amount || ""}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            [key]: { ...prev[key], amount: e.target.value },
                                          }))
                                        }
                                      />
                                      <TextField
                                        label="Remarks"
                                        size="small"
                                        value={formData[key]?.remarks || ""}
                                        onChange={(e) =>
                                          setFormData((prev) => ({
                                            ...prev,
                                            [key]: { ...prev[key], remarks: e.target.value },
                                          }))
                                        }
                                      />
                                    </Box>
                                  )}
                                </Box>
                              ))}
                            </>
                          )}
                        </Grid>
                      )}

                      {/* Submit Button - Only visible when !contract.latestStatus?.formI */}
                      <Grid
                        item
                        xs={12}
                        sx={{
                          display: "flex",
                          justifyContent: "center",
                          width: "100%",
                        }}
                      >
                        <Button
                          variant="contained"
                          color="success"
                          fullWidth
                          onClick={(e) =>
                            handleSubmit(
                              e,
                              contract.crewingAgent?.[0]?._id || contract.crewingAgent?._id
                            )
                          }
                          sx={{ height: "40px" }}
                        >
                          {loading ? <CircularProgress size={24} color="inherit" /> : "Submit"}
                        </Button>
                      </Grid>
                    </>
                  ) : null}
                </>
              )}
            </Grid>
          </CardContent>
        </Card>



      </Box>


      {/* Documents Modal */}
      <Dialog open={openModal} onClose={() => setOpenModal(false)} fullWidth>
        <DialogTitle>{modalTitle}</DialogTitle>
        <DialogContent>
          {modalDocuments.length > 0 ? (
            modalDocuments.map((doc, index) => (
              <Paper
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  p: 2,
                  mb: 2,
                  borderRadius: "8px",
                  boxShadow: 1,
                }}
              >
                {/* Document Icon and Name */}
                <Box display="flex" alignItems="center" gap={1}>
                  <Typography variant="body1">{index + 1}.</Typography>
                  <PictureAsPdfIcon sx={{ color: "red", mr: 1 }} />
                  <Typography variant="body1">{doc.name}</Typography>
                </Box>


                {/* Download Button or No File Message */}
                {doc.filePath ? (
                  <Button
                    variant="contained"
                    href={doc.filePath.startsWith("http") ? doc.filePath : `${baseURL}/${doc.filePath.replace(/\\/g, "/")}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Download
                  </Button>
                ) : (
                  <Box display="flex" alignItems="center">
                    <ReportProblemIcon sx={{ color: "orange", mr: 1 }} />
                    <Typography variant="body2" color="red">
                      No File Available
                    </Typography>
                  </Box>
                )}
              </Paper>
            ))
          ) : (
            <Box
              display="flex"
              flexDirection="column"
              alignItems="center"
              justifyContent="center"
              sx={{ py: 3 }}
            >
              <ReportProblemIcon sx={{ fontSize: 50, color: "orange" }} />{" "}
              {/* No Document Icon */}
              <Typography color="textSecondary" mt={1}>
                No documents available
              </Typography>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenModal(false)}>Close</Button>
        </DialogActions>
      </Dialog>


      <ToastContainer />
    </>
  );
};


export default EditContractTable;



